export enum Event {
  CallUnauthorized = 'callUnauthorized',
  CallForbidden = 'callForbidden',
  ConfigChange = 'configChange',
  ExternalFileShare = 'externalFileShare',
  NavigationReady = 'NavigationReady',
  PushNotificationOpened = 'PushNotificationOpened',
  Logout = 'logout',
}

interface Ref {
  name: Event;
  callback: (data: any) => void;
}
class EventRegister {
  static _Listeners = {
    count: 0,
    refs: {} as Record<string, Ref>,
  };

  static addEventListener(eventName: Event, callback: (data: any) => void) {
    EventRegister._Listeners.count++;
    const eventId = `l${EventRegister._Listeners.count}`;
    EventRegister._Listeners.refs[eventId] = {
      name: eventName,
      callback,
    };
    return eventId;
  }

  static addEventListeners(eventNames: Event[], callback: (data: any) => void) {
    return eventNames.map((eventName) => this.addEventListener(eventName, callback));
  }

  static removeEventListener(id: string) {
    delete EventRegister._Listeners.refs[id];
  }

  static removeEventListeners(ids: string[]) {
    ids.forEach((id) => this.removeEventListener(id));
  }

  static emit(eventName: Event, data?: any) {
    Object.values(EventRegister._Listeners.refs).forEach(({ name, callback }) => {
      if (eventName === name) callback(data);
    });
  }
}

export default EventRegister;
